import type { IconProps } from "./icon-types";

/**
 * 정지(stop). DataReview 재생 컨트롤 등에서 사용.
 *
 * 글리프는 `react-icons/lu`의 `LuSquare`(Lucide `square`) 기반 —
 * 미디어 컨트롤 관례에 맞춰 채움(fill) 처리. c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 */
export const StopIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
  </svg>
);
